import CryptoJS from "crypto-js";
export const SECRET_KEY = CryptoJS.enc.Utf8.parse("69643446f251923a");
export const SECRET_IV = CryptoJS.enc.Utf8.parse("1b8f27804a37cf46");
// 24 小时
export const DEFAULT_EXPIRE_TIME = 24 * 3600;
// 单一变量合集
export const VARIABLE_GARD_TOKEN = "VGTToken";